import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "b-room-edit-popup" }
const _hoisted_2 = { class: "b-room-edit-popup__inner h-text-center" }
const _hoisted_3 = { class: "h-flex h-flex-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "h-mt-30 h-width-100p h-font-18 h-fw-700 h-ph-20 h-text-center"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "h-flex h-flex-dir-column h-flex-center"
}
const _hoisted_8 = {
  key: 2,
  class: "h-flex h-flex-dir-column h-flex-center"
}
const _hoisted_9 = { class: "h-font-18 h-fw-500 h-text-center h-mt-40 h-mb-20" }
const _hoisted_10 = { class: "b-room-edit-popup--footer h-flex h-flex-center" }
const _hoisted_11 = { class: "h-flex h-flex-center h-flex-dir-column h-mh-30" }
const _hoisted_12 = { class: "h-mt-10 h-font-18 h-fw-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_FwSpinLoader = _resolveComponent("FwSpinLoader")!
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_FwIcon, {
        class: "b-room-edit-popup__inner__icon",
        icon: "close",
        size: "15",
        color: "#BEC7D4",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("close")))
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _ctx.requireImage("doors-img.svg")
        }, null, 8, _hoisted_4)
      ]),
      (_ctx.isLoading || _ctx.isRoomAvailable || _ctx.isRoomIsNotAvailable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('SITE.ROOM.LOADING.TEXT')), 1),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_FwSpinLoader, {
                        key: 0,
                        style: {"position":"relative"},
                        colors: ["#27dbbd", "#27DBBD", "#27DBBD"],
                        class: "b-global-loading h-pos-rel b-global-loading--transparent",
                        isActive: _ctx.isLoading,
                        className: "h-p-20"
                      }, null, 8, ["isActive"]))
                    : _createCommentVNode("", true)
                ]))
              : (_ctx.isRoomAvailable)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_ctx.$t('SITE.ROOM.AVAILABLE')) + " ", 1),
                    _createVNode(_component_FwButton, {
                      class: "h-mt-30",
                      borderRadiusType: "small-border",
                      onClick: _ctx.onSubmit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Ok')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_FwButton, {
                      class: "qa-show-edit-popup-button h-mt-20",
                      color: "transparent",
                      fontSize: "16px",
                      style: {"min-width":"100px","text-align":"left"},
                      onClick: _ctx.backToChoose
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('SITE.ROOM.CHOOSE.ROOM')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : (_ctx.isRoomIsNotAvailable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createTextVNode(_toDisplayString(_ctx.$t('SITE.ROOM.NOT.AVAILABLE')) + " ", 1),
                      _createVNode(_component_FwButton, {
                        class: "h-mt-30 h-width-250 qa-remove-alone",
                        borderRadiusType: "small-border",
                        onClick: _ctx.backToChoose
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('SITE.ROOM.CHECK.AVAILABILITIES')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createElementVNode("div", {
                        class: "b-delete-popup__delete h-mt-20",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("backToCalendar")))
                      }, _toDisplayString(_ctx.$t('BUTTON.CANCEL')), 1)
                    ]))
                  : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('SITE.ROOM.SELECT')), 1),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sitesArray, (site) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_FwButton, {
                    borderRadiusType: "small-border",
                    onClick: ($event: any) => (_ctx.getRoomData(site))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FwIcon, {
                        icon: "icon-door",
                        size: "45",
                        color: "#fff"
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(site.name), 1)
                ]))
              }), 256))
            ])
          ], 64))
    ])
  ]))
}